// src/pages/Users/News/components/NewsSkeleton.jsx

import React from "react";

export default function NewsSkeleton() {
  return (
    <div className="grid grid-cols-1 gap-5 md:grid-cols-2 xl:grid-cols-3">
      {Array.from({ length: 6 }).map((_, index) => (
        <div
          key={index}
          className="overflow-hidden rounded-[2rem] border border-slate-200 bg-white shadow-sm dark:border-slate-800 dark:bg-slate-900"
        >
          <div className="aspect-[16/10] animate-pulse bg-slate-200 dark:bg-slate-800" />

          <div className="space-y-3 p-5">
            <div className="h-4 w-32 animate-pulse rounded-full bg-slate-200 dark:bg-slate-800" />
            <div className="h-5 w-full animate-pulse rounded-full bg-slate-200 dark:bg-slate-800" />
            <div className="h-5 w-4/5 animate-pulse rounded-full bg-slate-200 dark:bg-slate-800" />
            <div className="h-4 w-full animate-pulse rounded-full bg-slate-200 dark:bg-slate-800" />
            <div className="h-4 w-3/4 animate-pulse rounded-full bg-slate-200 dark:bg-slate-800" />

            <div className="mt-4 grid grid-cols-2 gap-3">
              <div className="h-11 animate-pulse rounded-2xl bg-slate-200 dark:bg-slate-800" />
              <div className="h-11 animate-pulse rounded-2xl bg-slate-200 dark:bg-slate-800" />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}